import instance from './instance';

export const fetchWorkspaceItemComments = params => instance.get('/workspace_comments', { params });

export const createWorkspaceItemComment = data => instance.postForm(`/workspace_comments/`, data);

export const updateWorkspaceItemComment = data => instance.put(`/workspace_comments/${data.slug}`, data);

export const deleteWorkspaceItemComment = workspaceItemCommentUuid =>
  instance.delete(`/workspace_comments/${workspaceItemCommentUuid}`);
